import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MecsDashboardComponent } from './pages/mecs-dashboard/mecs-dashboard.component';
import { MecsHomePageComponent } from './pages/mecs-home-page/mecs-home-page.component';
import { MecsDashboardRegionalComponent } from './pages/mecs-dashboard-regional/mecs-dashboard-regional.component';
import { MecsInDepthComponent } from './pages/mecs-in-depth/mecs-in-depth.component';

const routes: Routes = [
  {
    path: '',
    component: MecsHomePageComponent,
  },
  {
    path: 'dashboard',
    component: MecsDashboardComponent,
  },
  {
    path: 'in-depth',
    component: MecsInDepthComponent,
  },
  {
    path: 'region/:id',
    component: MecsDashboardRegionalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MecsDashboardRoutingModule { }
